"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PtoBalanceBreakdownView = PtoBalanceBreakdownView;
exports.default = PtoBalanceSummaryBreakdown;
exports.PtoBalanceSummaryBreakdown = PtoBalanceSummaryBreakdown;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("@react-navigation/native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_i18next_1 = require("react-i18next");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const PlatformModal_1 = __importDefault(require("../components/PlatformModal"));
const Button_1 = __importDefault(require("../components/Button"));
const UserContext_1 = require("../contexts/UserContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        container: {
            paddingTop: 0,
            paddingBottom: 0,
            width: '100%',
        },
        headerRow: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 16,
        },
        headerTitleContainer: {
            flex: 1,
            marginLeft: 12,
        },
        headerTitle: {
            color: THEME.Text,
            fontWeight: '600',
            fontSize: size !== 'sm' ? 18 : 16,
        },
        headerSubText: {
            color: THEME.TextLight,
            fontSize: size !== 'sm' ? 13 : 12,
            marginTop: 2,
        },
        highlightCard: {
            borderWidth: 1,
            borderColor: THEME.LightGray,
            borderRadius: 8,
            backgroundColor: THEME.OffWhite,
            paddingVertical: 14,
            paddingHorizontal: 12,
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 8,
        },
        highlightLabel: {
            fontSize: 13,
            fontWeight: '600',
            color: THEME.TextSecondary,
            textTransform: 'uppercase',
            letterSpacing: 0.5,
            marginBottom: 6,
        },
        highlightValue: {
            fontSize: size !== 'sm' ? 36 : 30,
            fontWeight: '700',
            color: THEME.Primary,
        },
        highlightSub: {
            fontSize: 12,
            color: THEME.TextLight,
            marginTop: 4,
        },
        equationCard: {
            borderWidth: 1,
            borderColor: THEME.LightGray,
            borderRadius: 8,
            backgroundColor: THEME.OffWhite,
            paddingVertical: 10,
            paddingHorizontal: 16,
            marginBottom: 6,
            alignItems: 'center',
        },
        equationContent: {
            width: '100%',
            maxWidth: size !== 'sm' ? 280 : 250,
            alignSelf: 'center',
        },
        equationRow: {
            flexDirection: 'row',
            alignItems: 'center',
            paddingVertical: 6,
        },
        valueCol: {
            flexDirection: 'row',
            alignItems: 'center',
            width: size !== 'sm' ? 120 : 105,
        },
        operatorText: {
            width: 24,
            fontSize: size !== 'sm' ? 16 : 14,
            fontWeight: '600',
            color: THEME.TextSecondary,
            textAlign: 'center',
        },
        operatorSpacer: {
            width: 24,
        },
        valueText: {
            flex: 1,
            fontSize: size !== 'sm' ? 16 : 15,
            fontWeight: '600',
            color: THEME.Text,
            textAlign: 'right',
        },
        headerCol: {
            flex: 1,
            marginLeft: 16,
        },
        headerText: {
            fontSize: size !== 'sm' ? 15 : 14,
            fontWeight: '500',
            color: THEME.TextSecondary,
        },
        equationDivider: {
            height: 1,
            backgroundColor: THEME.LightGray,
            marginVertical: 6,
            width: '100%',
        },
        totalOperatorText: {
            width: 24,
            fontSize: size !== 'sm' ? 18 : 16,
            fontWeight: '700',
            color: THEME.Primary,
            textAlign: 'center',
        },
        totalValueText: {
            flex: 1,
            fontSize: size !== 'sm' ? 18 : 16,
            fontWeight: '700',
            color: THEME.Primary,
            textAlign: 'right',
        },
        totalHeaderText: {
            fontSize: size !== 'sm' ? 15 : 14,
            fontWeight: '700',
            color: THEME.Text,
        },
        scheduledCard: {
            borderWidth: 1,
            borderColor: THEME.LightGray,
            borderRadius: 8,
            backgroundColor: THEME.OffWhite,
            paddingVertical: 10,
            paddingHorizontal: 16,
            marginBottom: 6,
            alignItems: 'center',
        },
        unlimitedRow: {
            flexDirection: 'row',
            gap: 12,
            marginBottom: 6,
        },
        unlimitedCard: {
            flex: 1,
            borderWidth: 1,
            borderColor: THEME.LightGray,
            borderRadius: 8,
            backgroundColor: THEME.OffWhite,
            paddingVertical: 14,
            paddingHorizontal: 12,
            alignItems: 'center',
            justifyContent: 'center',
        },
        unlimitedLabel: {
            fontSize: 12,
            fontWeight: '600',
            color: THEME.TextSecondary,
            textTransform: 'uppercase',
            letterSpacing: 0.5,
            marginBottom: 4,
            textAlign: 'center',
        },
        unlimitedValue: {
            fontSize: size !== 'sm' ? 24 : 20,
            fontWeight: '700',
            color: THEME.Text,
            textAlign: 'center',
        },
        unlimitedSub: {
            fontSize: 11,
            color: THEME.TextLight,
            marginTop: 2,
            textAlign: 'center',
        },
        buttonRow: {
            flexDirection: 'row',
            marginTop: 16,
            marginBottom: size === 'sm' ? 8 : 0,
            gap: 8,
        },
        buttonWrapper: {
            flex: 1,
        },
    });
};
function PtoBalanceBreakdownView(props) {
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const navigationHook = (0, native_1.useNavigation)();
    const navigation = props.navigation ?? navigationHook;
    const { t } = (0, react_i18next_1.useTranslation)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const styles = useStyles();
    const showScheduledPtoFeature = userContext?.client?.features?.find((feature) => feature?.name === 'show-scheduled-pto' || feature?.name === 'show-scheduled_pto');
    const showScheduled = props.showScheduled ?? !!showScheduledPtoFeature?.isEnabled;
    const timeAndAttendance = userContext?.client?.features?.find((feature) => feature?.name === 'time-and-attendance');
    const showScheduleButton = !props.approverView && timeAndAttendance?.isEnabled && !timeAndAttendance?.usesRedirect;
    const isScheduleDisabled = !props.balance?.register || props.balance?.enabled === false;
    const balance = props.balance;
    const isUnlimited = !!balance?.unlimited;
    const currentBalanceValue = isUnlimited
        ? t('time:text.unlimited')
        : (balance?.remaining ?? '0.00');
    const earnedValue = isUnlimited
        ? '—'
        : (balance?.earned ?? balance?.accrued ?? '0.00');
    const carryoverValue = isUnlimited
        ? '—'
        : (balance?.carryover ?? '0.00');
    const takenValue = balance?.taken ?? '0.00';
    const scheduledHoursValue = balance?.scheduled ?? '0.00';
    const handleSchedulePto = react_1.default.useCallback(() => {
        if (!balance?.register)
            return;
        if (userContext?.isImpersonated) {
            react_native_1.DeviceEventEmitter.emit('event.showSnackbar', {
                type: 'warning',
                message: t('common:messages.impersonatedUser'),
            });
            return;
        }
        props.onClose?.();
        navigation.navigate('PtoRequest', {
            registerName: balance?.name,
            register: balance?.register,
        });
    }, [balance?.name, balance?.register, navigation, props.onClose, t, userContext?.isImpersonated]);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.container, children: [props.showHeader && ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.headerRow, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.CalendarCheck, size: 22, color: THEME.Secondary }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.headerTitleContainer, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.headerTitle, children: balance?.name ? balance.name : t('time:text.pto') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.headerSubText, children: t('time:headers.ptoBalances') })] }), props.onClose && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -8 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('common:buttons.close'), hitSlop: 12, type: "borderless", onPress: props.onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) }))] })), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [STYLES.notSelectable, styles.highlightCard], children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.highlightLabel, children: t('time:text.currentBalance') }), isUnlimited ? ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: size !== 'sm' ? 8 : 4 }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.Infinity, size: size !== 'sm' ? 36 : 30, style: { overflow: 'visible' }, color: THEME.Primary }) })) : ((0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.highlightValue, children: currentBalanceValue })), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.highlightSub, children: isUnlimited ? t('time:text.discretionaryUse') : t('time:text.hoursRemain') })] }), isUnlimited ? (
            /* Unlimited PTO: Only show Taken and Scheduled Hours side-by-side */
            (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [STYLES.notSelectable, styles.unlimitedRow], children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.unlimitedCard, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.unlimitedLabel, children: t('time:text.taken') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.unlimitedValue, children: takenValue }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.unlimitedSub, children: t('time:text.capsHours') })] }), showScheduled && ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.unlimitedCard, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.unlimitedLabel, children: t('time:text.scheduledHours') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.unlimitedValue, children: scheduledHoursValue }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.unlimitedSub, children: t('time:text.capsHours') })] }))] })) : (
            /* Standard PTO: Vertical Equation Table + Scheduled Hours below */
            (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.notSelectable, styles.equationCard], children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.equationContent, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.equationRow, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.valueCol, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.operatorSpacer }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.valueText, children: earnedValue })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.headerCol, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.headerText, children: t('time:text.earned') }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.equationRow, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.valueCol, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.operatorText, children: "+" }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.valueText, children: carryoverValue })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.headerCol, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.headerText, children: t('time:text.carryover') }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.equationRow, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.valueCol, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.operatorText, children: "\u2212" }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.valueText, children: takenValue })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.headerCol, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.headerText, children: t('time:text.taken') }) })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.equationDivider }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.equationRow, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.valueCol, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.totalOperatorText, children: "=" }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.totalValueText, children: currentBalanceValue })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.headerCol, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.totalHeaderText, children: t('time:text.currentBalance') }) })] })] }) }), showScheduled && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.notSelectable, styles.scheduledCard], children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.equationContent, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.equationRow, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.valueCol, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.operatorSpacer }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.valueText, children: scheduledHoursValue })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.headerCol, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.headerText, children: t('time:text.scheduledHours') }) })] }) }) }))] })), (showScheduleButton && !props.balance?.enabled === false) && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.buttonRow, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.buttonWrapper, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "solid", text: t('time:buttons.request'), disabled: isScheduleDisabled, onPress: handleSchedulePto }) }) }))] }));
}
function PtoBalanceSummaryBreakdown(props) {
    return ((0, jsx_runtime_1.jsx)(PlatformModal_1.default, { isVisible: props.isVisible, onDismiss: props.onDismiss, children: (0, jsx_runtime_1.jsx)(PtoBalanceBreakdownView, { balance: props.balance, showScheduled: props.showScheduled, navigation: props.navigation, approverView: props.approverView, showHeader: true, onClose: props.onDismiss }) }));
}
